import type { UseInfiniteQueryOptions } from "react-query"
import { useInfiniteQuery } from "react-query"

import type {
  ArticlesListQuery,
  ArticlesListQueryVariables,
} from "~/api/prismic/graphql"
import {
  ArticlesListDocument,
  sendPrismicGraphQLRequest,
} from "~/api/prismic/graphql"
import { QueryCacheKeys } from "~/state/ReactQuery"

export const useAllArticlesAndEpisodesQuery = <TData>(
  variables: ArticlesListQueryVariables,
  options: UseInfiniteQueryOptions<ArticlesListQuery, unknown, TData>,
) => {
  return useInfiniteQuery<ArticlesListQuery, unknown, TData>(
    [QueryCacheKeys.ALL_ARTICLES_AND_EPISODES, variables],
    async ({ pageParam }) => {
      return sendPrismicGraphQLRequest<
        ArticlesListQuery,
        ArticlesListQueryVariables
      >({
        query: ArticlesListDocument,
        variables: { ...variables, after: pageParam },
      })
    },
    {
      getNextPageParam: (lastPage) => {
        const results = lastPage._allDocuments.edges
        const pageSize = variables?.pageSize

        return pageSize && results && results[pageSize - 1]?.cursor
      },
      ...options,
    },
  )
}
